import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

import LinkButton from '~/components/Buttons/LinkButton'
import * as ROUTES from '~/constants/routes'

import ActionButtons from './ActionButtons'

import { IFrameStyled } from '../styled/IFrame.styled'

function ProductImportStep ({ onSkip }) {
  return (
    <Box>
      <Typography variant="h5" gutterBottom={true}>
        Import product data
      </Typography>
      <Box>
        <IFrameStyled
          src="https://www.youtube.com/embed/SxunQf57Rbk"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        />
      </Box>
      <ActionButtons onSkip={onSkip}>
        <LinkButton href={ROUTES.PRODUCT_IMPORT_PATH} target="_blank">Import</LinkButton>
      </ActionButtons>
    </Box>
  )
}

ProductImportStep.propTypes = {
  onSkip: PropTypes.func.isRequired
}

export default ProductImportStep
